import {
  ClaimDefinition,
  StepDefinitionTypes,
  PharmaCompany,
  DosingFrequencyUnit,
  ClaimClearance,
} from 'claimbuilder'

import infoDoc from './assets/Metamorphoses.pdf'
import logo from './assets/Metamorphoses.png'

export const MetamorphosisClaimDefinition: ClaimDefinition = {
  product: {
    name: 'Metamorphoses',
    informationDocument: infoDoc,
    substances: ['Placebo'],
    logo,
  },
  clearance: ClaimClearance.DEMO,
  owner: PharmaCompany.DEMO,
  steps: [
    {
      type: StepDefinitionTypes.DOCTOR,
    },
    {
      type: StepDefinitionTypes.PATIENT,
      diagnoseOptions: [
        {
          label: 'Diagnose 1',
          value:
            'Diagnose 1: Lorem ipsum dolor sit amet, consetetur sadipscing elitr',
        },
        {
          label: 'Diagnose 2',
          value:
            'Diagnose 2: Sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat',
        },
        {
          label: 'Diagnose 3',
          value:
            'Diagnose 3: At vero eos et accusam et justo duo dolores et ea rebum',
        },
        {
          label: 'Diagnose 4',
          value:
            'Diagnose 4: Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
        },
      ],
    },
    {
      type: StepDefinitionTypes.DOSING,
      unit: 'Gramm',
      frequencyUnit: DosingFrequencyUnit.WEEK,
      frequencies: [
        {
          label: 'jede Woche',
          value: 1,
        },
        {
          label: 'alle 2 Wochen',
          value: 2,
        },
        {
          label: 'alle 3 Wochen',
          value: 3,
        },
        {
          label: 'alle 4 Wochen',
          value: 4,
        },
        {
          label: 'sonstiges',
          value: 'CUSTOM',
        },
      ],
      dosings: [
        {
          value: 2.5,
        },
        {
          value: 5,
        },
        {
          value: 7.5,
        },
        {
          value: 10,
        },
        {
          value: 12.5,
        },
        {
          value: 15,
        },
        {
          value: 17.5,
        },
        {
          value: 20,
        },
        {
          value: 22.5,
        },
        {
          value: 25,
        },
        {
          value: 27.5,
        },
        {
          value: 30,
        },
        {
          value: 32.5,
        },
        {
          value: 35,
        },
        {
          value: 37.5,
        },
        {
          value: 40,
        },
        {
          value: 42.5,
        },
        {
          value: 45,
        },
        {
          value: 47.5,
        },
        {
          value: 50,
        },
        {
          value: 52.5,
        },
        {
          value: 55,
        },
        {
          value: 57.5,
        },
        {
          value: 60,
        },
        {
          value: 62.5,
        },
        {
          value: 65,
        },
        {
          value: 67.5,
        },
        {
          value: 70,
        },
        {
          value: 72.5,
        },
        {
          value: 75,
        },
        {
          value: 77.5,
        },
        {
          value: 80,
        },
        {
          value: 82.5,
        },
        {
          value: 85,
        },
        {
          value: 87.5,
        },
        {
          value: 90,
        },
        {
          value: 92.5,
        },
        {
          value: 95,
        },
        {
          value: 97.5,
        },
        {
          value: 100,
        },
      ],
    },
    {
      type: StepDefinitionTypes.ARGUMENTS,
      arguments: [
        {
          label: 'Lorem ipsum',
          description: '',
        },
        {
          label: 'Dolor sit amet',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat',
        },
        {
          label: 'Sed diam voluptua',
          description:
            'At vero eos et accusam et justo duo dolores et ea rebum',
        },
        {
          label: 'Stet clita kasd gubergren',
          description: 'No sea takimata sanctus est Lorem ipsum dolor sit amet',
        },
        {
          label: 'Lorem ipsum dolor sit amet',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua',
        },
        {
          label: 'Ut wisi enim ad minim veniam, quis nostrud exerci',
          description:
            'Tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi',
        },
        {
          label: 'Lorem ipsum dolor sit',
          description:
            'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua',
        },
        {
          label: 'At vero eos et accusam et justo duo dolores et ea rebum',
          description:
            'Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet',
        },
        {
          label: 'Nam liber tempor cum soluta nobis',
          description: '',
        },
      ],
    },
    {
      type: StepDefinitionTypes.DISPATCH,
    },
    {
      type: StepDefinitionTypes.SUMMARY,
    },
  ],
}

export default MetamorphosisClaimDefinition
